var _defs, _g, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a0f18c6b8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0f18c6b8f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 45 L 0 45 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e64a19",
    d: "M 19.6875 15.46875 L 15.9375 15.46875 C 14.125 15.46875 12.65625 14 12.65625 12.1875 C 12.65625 10.375 14.125 8.90625 15.9375 8.90625 L 19.6875 8.90625 Z M 19.6875 15.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c4dff",
    d: "M 19.21875 22.03125 L 15.9375 22.03125 C 14.125 22.03125 12.65625 20.5625 12.65625 18.75 C 12.65625 16.9375 14.125 15.46875 15.9375 15.46875 L 19.21875 15.46875 Z M 19.21875 22.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66bb6a",
    d: "M 15.9375 28.59375 C 14.125 28.59375 12.65625 27.125 12.65625 25.3125 C 12.65625 23.5 14.125 22.03125 15.9375 22.03125 L 19.21875 22.03125 L 19.21875 25.3125 C 19.21875 27.125 17.75 28.59375 15.9375 28.59375 Z M 15.9375 28.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    d: "M 22.5 15.46875 L 19.21875 15.46875 L 19.21875 8.90625 L 22.5 8.90625 C 24.3125 8.90625 25.78125 10.375 25.78125 12.1875 C 25.78125 14 24.3125 15.46875 22.5 15.46875 Z M 22.5 15.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M 25.78125 18.75 C 25.78125 19.183594 25.699219 19.605469 25.53125 20.003906 C 25.363281 20.40625 25.128906 20.761719 24.820312 21.070312 C 24.511719 21.378906 24.15625 21.613281 23.753906 21.78125 C 23.355469 21.949219 22.933594 22.03125 22.5 22.03125 C 22.066406 22.03125 21.644531 21.949219 21.246094 21.78125 C 20.84375 21.613281 20.488281 21.378906 20.179688 21.070312 C 19.871094 20.761719 19.636719 20.40625 19.46875 20.003906 C 19.300781 19.605469 19.21875 19.183594 19.21875 18.75 C 19.21875 18.316406 19.300781 17.894531 19.46875 17.496094 C 19.636719 17.09375 19.871094 16.738281 20.179688 16.429688 C 20.488281 16.121094 20.84375 15.886719 21.246094 15.71875 C 21.644531 15.550781 22.066406 15.46875 22.5 15.46875 C 22.933594 15.46875 23.355469 15.550781 23.753906 15.71875 C 24.15625 15.886719 24.511719 16.121094 24.820312 16.429688 C 25.128906 16.738281 25.363281 17.09375 25.53125 17.496094 C 25.699219 17.894531 25.78125 18.316406 25.78125 18.75 Z M 25.78125 18.75 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/FigmaLogo.540d8b9337eb11e7396c47123026a9d9.svg";
export { ForwardRef as ReactComponent };